import {useEffect, useRef} from "react";
import Header from "../../components/Header/Header";
import StartPage from "../StartPage/StartPage";
import Team from "../Team/Team";
import Descriptions from "../Descriptions/Descriptions";
import About from "../About/About";
import Partners from "../Partners/Partners";
import Contacts from "../Contacts/Contacts";
import Footer from "../../components/Footer/Footer";
import RoverVideo from "../../components/RoverVideo/RoverVideo";
import "./LandingPage.scss";

const LandingPage = () => {
    const bgRef = useRef(null);

    useEffect(() => {
        const element = bgRef.current;
        if (!element) return;

        const isHoverable = window.matchMedia("(pointer: fine)").matches;
        if (!isHoverable) return;
        let animationFrameId = null;

        const handleMouseMove = (e) => {
            if (animationFrameId) {
                cancelAnimationFrame(animationFrameId);
            }

            animationFrameId = requestAnimationFrame(() => {
                const rect = element.getBoundingClientRect();
                const x = e.pageX - (rect.left + window.scrollX);
                const y = e.pageY - (rect.top + window.scrollY);

                element.style.setProperty("--x", `${x}px`);
                element.style.setProperty("--y", `${y}px`);
            });
        };

        window.addEventListener("mousemove", handleMouseMove);

        return () => {
            window.removeEventListener("mousemove", handleMouseMove);
            if (animationFrameId) cancelAnimationFrame(animationFrameId);
        };
    }, []);

    return (
        <div className="LandingPage">
            <div className="LandingPage-bg" ref={bgRef}>
                <Header/>
                <StartPage/>
            </div>

            <Team id="team"/>
            <Descriptions/>
            <RoverVideo/>
            <About/>
            <Partners id="partners"/>
            <Contacts id="contact-us"/>
            <Footer/>
        </div>
    );
};

export default LandingPage;